import { Component, inject } from '@angular/core';
import { TariffTypeService } from '../proxy/controlling/controllers';
import { ListService } from '@abp/ng.core';
import {
  CardComponent,
  CardBodyComponent,
  ConfirmationService,
} from '@abp/ng.theme.shared';
import {
  TariffTypeCreateDto,
  TariffTypeDto,
  TariffTypeExcelDownloadDto,
  TariffTypeUpdateDto,
} from '../proxy/controlling/dtos/tariff-type';
import { TARIFFTYPE_CONFIG, TARIFFTYPE_FIELDS } from './tariff-type.config';
import { BaseCrudComponent, CrudPage, GenericForm } from '@zendra/shared';

@Component({
  selector: 'app-tariff-type',
  imports: [
    CardComponent,
    CardBodyComponent,
    CrudPage,
    GenericForm,
  ],
  providers: [ListService, TariffTypeService, ConfirmationService],
  templateUrl: './tariff-type.html',
  styleUrl: './tariff-type.scss',
})
export class TariffType extends BaseCrudComponent<
  TariffTypeDto,
  TariffTypeCreateDto,
  TariffTypeUpdateDto,
  TariffTypeExcelDownloadDto
> {
  service = inject(TariffTypeService);
  config = TARIFFTYPE_CONFIG;
  fields = TARIFFTYPE_FIELDS;

  protected prepareUpdateDto(data: any, selected: TariffTypeDto): TariffTypeUpdateDto {
    return {
      name: data.name,
      code: data.code,
      updateTariff: data.updateTariff,
      concurrencyStamp: selected.concurrencyStamp,
    };
  }

  protected getEntityName(): string {
    return 'TariffType';
  }
}
